import Image from "next/image";
import { User } from "lucide-react";
import { Typography } from "@drpcrd/shared/ui";
import { cn, formatCdnImg } from "@drpcrd/utils";

type Props = {
  name: string;
  handle: string;
  creatorSrc: string | null;
  socialAvatarSrc: string | null;
  avatarClassName?: string;
};

/**
 * Avatar, display name, and @handle for a creator card.
 * Uses next/image so avatars are served through /_next/image and benefit
 * from the minimumCacheTTL set in next.config.ts.
 */
export const CreatorInfo = ({
  name,
  handle,
  creatorSrc,
  socialAvatarSrc,
  avatarClassName,
}: Props) => {
  const avatarSrc = formatCdnImg(creatorSrc ?? socialAvatarSrc);

  return (
    <div className="flex items-center gap-1.5">
      <div
        className={cn(
          "bg-primary-50 relative flex size-4 shrink-0 items-center justify-center overflow-hidden rounded-full sm:size-5",
          avatarClassName,
        )}
      >
        {avatarSrc ? (
          <Image
            src={avatarSrc}
            alt={name}
            fill
            sizes="20px"
            className="object-cover"
          />
        ) : (
          <User className="text-primary-500 h-[60%] w-[60%]" />
        )}
      </div>
      <div className="flex min-w-0 flex-col">
        <Typography
          className="text-sm sm:text-base"
          weight="semibold"
          color="black"
        >
          {name}
        </Typography>
        <Typography className="text-dark text-xs sm:text-sm">
          {handle}
        </Typography>
      </div>
    </div>
  );
};
